import { createContext, useContext, useMemo, useState, type ReactNode, type ReactPortal } from 'react';
import { createPortal } from 'react-dom';

/**
 * G2b — header'in hemen ALTINDAKI filtre bari yuvasi (Yerlice `FiltreBar`'i gibi: `main`'in en ustunde, sayfa
 * dolgusunun disinda, yapisik ikinci bar). Kullanici 2026-09-15: "periyotlarin oldugu yer cok asagida, yerlicedeki
 * gibi direkt alt tarafinda olsun, navbarin altina bir bar daha gibi"; ayni gun "her zaman alt bar" secti (#493'teki
 * "sigarsa header" kalkti, header eski haline dondu).
 *
 * Yuvayi yalniz portal basan sayfa doldurur; bos yuvanin yuksekligi 0 -> diger ekranlar ve diger Template firmalari
 * birebir eski. Saglayici yoksa baglam varsayilani bos yuvadir; `FiltreBarPortal` o durumda hicbir sey basmaz.
 */
interface FiltreBarYuvasiDegeri {
  hedef: HTMLElement | null;
  setHedef: (el: HTMLElement | null) => void;
}

const BOS: FiltreBarYuvasiDegeri = { hedef: null, setHedef: () => {} };

const FiltreBarYuvasiBaglami = createContext<FiltreBarYuvasiDegeri>(BOS);

export function FiltreBarYuvasiSaglayici({ children }: { children: ReactNode }) {
  const [hedef, setHedef] = useState<HTMLElement | null>(null);
  const deger = useMemo(() => ({ hedef, setHedef }), [hedef]);
  return <FiltreBarYuvasiBaglami.Provider value={deger}>{children}</FiltreBarYuvasiBaglami.Provider>;
}

export function useFiltreBarYuvasi(): FiltreBarYuvasiDegeri {
  return useContext(FiltreBarYuvasiBaglami);
}

/** Cocugu filtre bari yuvasina basar. Hedef yoksa null. */
export function FiltreBarPortal({ children }: { children: ReactNode }): ReactPortal | null {
  const { hedef } = useFiltreBarYuvasi();
  return hedef ? createPortal(children, hedef) : null;
}
